import { render, staticRenderFns } from "./ManagerRequests.vue?vue&type=template&id=4b49b4b6&lang=pug&"
import script from "./ManagerRequests.vue?vue&type=script&lang=js&"
export * from "./ManagerRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports